import { useQuery } from '@tanstack/react-query';

import { chatApi, chatKeys } from '@/features/chat/api';

export function useChatHistory() {
  return useQuery({
    queryKey: chatKeys.history(),
    queryFn: () => chatApi.history(),
  });
}
